import React from 'react';

import { Route } from 'helpers/routes/routes';
import { CommonPageData, socThemeScreensUrl } from 'helpers/routes/CommonPageData';

export enum DashboardRoute {
  Dashboard = '/dashboard',
  EventHistoryList = '/dashboard/:entityTypeId/:entityRefNo/event-history',
  EventHistoryDetail = '/dashboard/:entityTypeId/:entityRefNo/event-history/:eventId',
}

const defaultJournalingCommonPageData: CommonPageData = {
  pageTitle: 'onecrm.common.pageTitle.journaling',
  visibleForAnonym: false,
};

export const DashboardRoutes: Route[] = [
  {
    path: DashboardRoute.EventHistoryList,
    exact: true,
    component: React.lazy(() => import('views/pages/EventHistoryList/EventHistoryList')),
    commonPageData: {
      ...defaultJournalingCommonPageData,
      pageId: '2.33.1',
      templateUrl: socThemeScreensUrl('2-33-1-historie.html'),
    },
  },
  {
    path: DashboardRoute.EventHistoryDetail,
    exact: true,
    component: React.lazy(() => import('views/pages/EventHistoryDetail/EventHistoryDetail')),
    commonPageData: {
      ...defaultJournalingCommonPageData,
      pageId: '2.33.1.1',
      templateUrl: socThemeScreensUrl('2-33-1-1-detail-historie.html'),
    },
  },
];
